module.exports = __webpack_public_path__ + "img/title-3.a5eca6ae.png";